import { create } from "zustand"

export const useModelDataStore = create((set) => ({
    uvSize: {x: 1040, y: 585},          // Total size of customization canvas
    labelSize: {x: 1040, y: 585},       // Size of subsection of canvas where the label UVs are located
    labelOffset: {x: 0, y: 0},          // Offset of the UV island
    updateUVData: (uvArray) => set((state) => {
        let u = Array.from(uvArray.filter((value, index) => index % 2 == 0))
        let v = Array.from(uvArray.filter((value, index) => index % 2 != 0))
        let bounds = {uMin: parseFloat(Math.min(...u).toFixed(3)),
                      uMax: parseFloat(Math.max(...u).toFixed(3)),
                      vMin: parseFloat(Math.min(...v).toFixed(3)),
                      vMax: parseFloat(Math.max(...v).toFixed(3))}
        let newData = { 
            labelSize: {
                x: Math.round(state.uvSize.x*(bounds.uMax-bounds.uMin)), 
                y: Math.round(state.uvSize.y*(bounds.vMax-bounds.vMin))
            },
            labelOffset: {
                x: Math.round(state.uvSize.x*bounds.uMin), 
                y: Math.round(state.uvSize.y*bounds.vMin)
            },        
        }
        // console.log(newData);
        return newData
    })
}))
